import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { Dropdown, Layout, Menu, Col, Row, Button, Typography } from 'antd';
import { LogoutOutlined, FlagOutlined } from '@ant-design/icons';
import Spain from '../../assets/Banderas/Spain.svg';
import Cataluna from '../../assets/Banderas/Cataluna.svg';
import EstadosUnidos from '../../assets/Banderas/EstadosUnidos.png';
import axios from 'axios';
import { useTranslation, withTranslation } from 'react-i18next';
import i18n from '../../i18n';
import env from '../../environment';
import { useSelector, useDispatch } from 'react-redux';
import { callAct } from '../../store/auth/actions';
import { logout } from '../../store/auth/actions';
import faqEV from '../../assets/icons/faqEV.png';
import user from '../../assets/icons/user.png';
import contactoEv from '../../assets/icons/contactoEv.png';

const { Header } = Layout;
const { Content, Sider } = Layout;
const { Text } = Typography;

function HeaderComponentMovile({ routesApp, npsComponent, alertClosed }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const [dataPersonal, setDataPersonal] = useState(null);
	const changeCallAct = useSelector((state) => state.auth.callAct);
	const dataProfile = useSelector((state) => state.data.dataProfile);
	const collapsed = useSelector((state) => state.data.collapseMenu);
	const changePage = useSelector((state) => state.data.changePage);
	const myRef = useRef();

	const rol = useSelector((state) => state.auth.roles);
	const userToken = useSelector((state) => state.auth.token);
	const { t } = useTranslation();
	const dataPersonalOperation = () => {
		axios
			.get(`${env.api.url}/v1/user/profile`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setDataPersonal(response.data.data.profile);
				dispatch(callAct(false));
			});
	};

	useEffect(() => {
		dataPersonalOperation();
	}, [changeCallAct]);
	useEffect(() => {
		dataPersonalOperation();
	}, []);

	useEffect(() => {
		myRef.current?.scrollTo(0, 0);
	}, [changePage]);

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
	};

	const subMenu1 = (
		<Menu>
			<Menu.Item onClick={() => changeLanguage('es')}>
				<img src={Spain} alt="SpainFlag" height="15px" style={{ marginRight: '5px' }} />
				ESPAÑOL
			</Menu.Item>
			<Menu.Item onClick={() => changeLanguage('en')}>
				<img src={EstadosUnidos} alt="EUFlag" height="15px" style={{ marginRight: '5px' }} />
				INGLES
			</Menu.Item>
			<Menu.Item onClick={() => changeLanguage('cat')}>
				<img src={Cataluna} alt="CataloniaFlag" height="15px" style={{ marginRight: '5px' }} />
				CATALAN
			</Menu.Item>
		</Menu>
	);

	const logoutUser = () => {
		dispatch(logout({ navigate }));
	};

	const menu = (
		<Menu>
			<Menu.SubMenu
				style={{ display: 'flex' }}
				title={
					<>
						<FlagOutlined style={{ marginTop: '5px', marginRight: 5 }} />
						{t('init.languages')}
					</>
				}>
				{subMenu1}
			</Menu.SubMenu>
			<Menu.Item danger onClick={logoutUser}>
				<LogoutOutlined style={{ marginRight: 5 }} />
				{t('init.logout')}
			</Menu.Item>
		</Menu>
	);

	return (
		<>
			<Row>
				<Col xs={24} sm={24}>
					<Header
						className="ant-layout-header g-header"
						style={{
							zIndex: 1000,
							backgroundColor: '#FFFFFF',
							borderBottom: '1px solid rgba(64, 64, 64, 0.08)',
							display: 'flex',
							justifyContent: 'space-between',
							position: 'fixed',
							alignItems: 'center',
							width: '100%',
							padding: 24
						}}>
						<img src="/images/engel-logo-mobile.svg" style={{ height: '28px' }} alt="iconEV" />
						<div style={{ marginTop: 15 }}>
							{dataProfile && dataProfile.avatar ? (
								<Dropdown overlay={menu} placement="bottomRight" arrow trigger={['click']}>
									<a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
										<Button
											style={{
												border: 'none',
												width: 26,
												height: 28,
												borderRadius: 20
											}}
											icon={
												<img
													style={{
														border: 'none',
														width: 28,
														height: 28,
														borderRadius: 20
													}}
													size={30}
													src={`data:image/png;base64,${
														dataProfile && dataProfile.avatar.data
													}`}></img>
											}
										/>
									</a>
								</Dropdown>
							) : (
								<Dropdown overlay={menu} placement="bottomRight" arrow trigger={['click']}>
									<Button
										style={{ border: 'none', width: 36, height: 40 }}
										icon={
											<img
												style={{
													border: 'none',
													width: 28,
													height: 28,
													borderRadius: 20
												}}
												size={36}
												src={user}></img>
										}
									/>
								</Dropdown>
							)}
						</div>
					</Header>
				</Col>
			</Row>

			<Content>
				<div ref={myRef} className="mobileComponentScroll">
					{npsComponent}
					{routesApp}
				</div>
			</Content>
		</>
	);
}

export default withTranslation()(HeaderComponentMovile);
